import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      detailsRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 100)
      ],
      siteRules: [
        v => Rules.isRequired(v),
      ],
      vehicleRules: [
        v => Rules.isRequired(v),
      ],
      driverRules: [
      ],
      vehicleTypeRules: [
        v => Rules.isRequired(v),
      ],
      spoilRules: [
        v => Rules.isRequired(v),
      ],
      tipRules: [
        v => Rules.isRequired(v),
      ],
      estimatedSpoilAmountRules: [
        v => Rules.isNumber(v)
      ]
    }
  }
}

